import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from "../../context/AuthContext";
import { ToastContext } from '../../context/ToastContext';
import { postQuestionToSeller } from '../../_services/carsService';
const AskSellarQuestion = ({ onSubmitQuestion, car }) => {
  const [showModal, setShowModal] = useState(false);
  const [question, setQuestion] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [loading, setLoading] = useState(false);
  const { isLoggedIn,userInfo } = useContext(AuthContext);
  const { showToast } = useContext(ToastContext);

  const handleOpen = () => {
    if (isLoggedIn) {
      setShowModal(true);
      setSubmitted(false);
      setFadeOut(false);
      setQuestion('');
    } else {
      const loginEvent = new Event("openLoginModal");
      window.dispatchEvent(loginEvent);
    }
  };

  const handleSubmit = async () => {
    if (!question.trim()) return;

    try {
      setLoading(true);
      await postQuestionToSeller(question.trim(), car.id); // Call the API
      onSubmitQuestion(question.trim()); // Update local list
      setShowModal(false);
      setSubmitted(true);
      setFadeOut(false);
      showToast("Your question has been submitted", "dark");
    } catch (error) {
      showToast(error || "Failed to submit question", "danger");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (submitted) {
      const fadeTimer = setTimeout(() => setFadeOut(true), 2500);
      const hideTimer = setTimeout(() => setSubmitted(false), 3000);
      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(hideTimer);
      };
    }
  }, [submitted]);

  return (
    <>
      {/* Main Clickable Box */}
      <button
        onClick={handleOpen}
        className="btn btn-light" // You can change the class if you want different styling
        style={{
          height: '250px',
          border: '1px solid #ccc',
          borderRadius: '8px',
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '16px',
          backgroundColor: '#f8f9fa',
          cursor: car?.seller_email === userInfo?.email ? 'not-allowed' : 'pointer',
          pointerEvents: car?.seller_email === userInfo?.email ? 'none' : 'auto',
        }}
        disabled={car?.seller_email === userInfo?.email}
      >
        Ask a question
      </button>

      {/* Modal */}
      {showModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, height: '100vh', width: '100vw',
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center',
          alignItems: 'center', zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white', padding: '20px', borderRadius: '8px',
            width: '400px', position: 'relative'
          }}>
            <button onClick={() => setShowModal(false)} style={{
              position: 'absolute', top: '10px', right: '10px', border: 'none',
              background: 'transparent', fontSize: '18px', cursor: 'pointer',
              fontWeight: 'bold',
            }}>
              X
            </button>

            <h5 style={{ marginTop: '20px' }}>Post your question</h5>
            <textarea
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              rows="4"
              style={{ width: '100%', marginBottom: '10px', padding: '8px' }}
              placeholder="Type your question here..."
              disabled={loading}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button onClick={handleSubmit} disabled={!question.trim() || loading}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AskSellarQuestion;
